import { Link } from "react-router-dom";
import { comicCategories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="flex flex-col lg:flex-row lg:justify-between gap-10">
          <div className="max-w-sm">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-leaf-fill text-background-50 text-xl"></i>
              </span>
              <span className="font-brand text-2xl leading-none tracking-wide">
                蛙漫
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-100/80">
              蛙漫是面向漫画与动漫爱好者的在线阅读平台，汇集多种题材的连载与完结作品，并提供最新的动漫资讯与更新动态。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {[
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-wechat-line", label: "微信" },
                { icon: "ri-bilibili-line", label: "B站" },
                { icon: "ri-mail-line", label: "邮箱" },
              ].map((item) => (
                <span
                  key={item.icon}
                  title={item.label}
                  className="w-9 h-9 flex items-center justify-center rounded-md bg-white/10 hover:bg-white/20 transition-colors cursor-pointer"
                >
                  <i className={`${item.icon} text-lg`}></i>
                </span>
              ))}
            </div>
          </div>

          <div className="flex flex-wrap gap-10 md:gap-16">
            <div>
              <h4 className="text-sm font-label font-bold mb-4">
                <a href="#footer-nav" className="hover:text-accent-300">
                  快速导航
                </a>
              </h4>
              <ul id="footer-nav" className="flex flex-col gap-3 text-sm">
                <li>
                  <Link to="/" className="text-background-100/80 hover:text-accent-300">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/news" className="text-background-100/80 hover:text-accent-300">
                    动漫资讯
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-background-100/80 hover:text-accent-300">
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-label font-bold mb-4">
                <a href="#footer-cat" className="hover:text-accent-300">
                  热门分类
                </a>
              </h4>
              <ul id="footer-cat" className="flex flex-col gap-3 text-sm">
                {comicCategories.slice(0, 4).map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.id}`}
                      className="text-background-100/80 hover:text-accent-300"
                    >
                      {cat.name}漫画
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-label font-bold mb-4">
                <a href="#footer-contact" className="hover:text-accent-300">
                  联系我们
                </a>
              </h4>
              <ul id="footer-contact" className="flex flex-col gap-3 text-sm text-background-100/80">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-accent-300"></i>
                  hello@waman-comic.com
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-phone-line text-accent-300"></i>
                  400-800-2026
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-map-pin-line text-accent-300"></i>
                  滨江会展中心 3 号馆
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-100/70 text-center sm:text-left">
            © 2026 蛙漫 · 本站为演示项目，全部漫画与资讯均为虚构内容，仅供学习交流。
          </p>
          <p className="text-xs text-background-100/70">
            内容版权声明 · 未经许可禁止转载
          </p>
        </div>
      </div>
    </footer>
  );
}